// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3d_Me","requiredAsterisk":"Info_requiredAsterisk__FBUfz"};